/** Un pourcentage au format français : « 21,4 % », espace insécable avant le signe. */
export const pourcent = (n: number | null | undefined, decimales = 1): string =>
  n === null || n === undefined || Number.isNaN(n)
    ? 'n/a'
    : `${n.toLocaleString('fr-CH', { maximumFractionDigits: decimales })} %`;
